type PartialRect = Pick<
  DOMRect,
  'x' | 'y' | 'width' | 'height' | 'top' | 'left' | 'right' | 'bottom'
>;

const createRect = ({
  x,
  y,
  width,
  height,
}: {
  x: number;
  y: number;
  width: number;
  height: number;
}): PartialRect => ({
  x,
  y,
  width,
  height,
  top: y,
  left: x,
  right: x + width,
  bottom: y + height,
});

export const getRelativeRect = (
  elementRect?: DOMRect,
  containerRect?: DOMRect
) => {
  if (!elementRect || !containerRect) {
    return null;
  }

  const x = elementRect.x - containerRect.x;
  const y = elementRect.y - containerRect.y;

  return createRect({
    x,
    y,
    width: elementRect.width,
    height: elementRect.height,
  });
};

// in case we need to know the side at some point, see: https://silentmatt.com/rectangle-intersection/
export const areRectsIntersecting = (
  rectA: PartialRect,
  rectB: PartialRect
): boolean =>
  !(
    rectB.left >= rectA.right ||
    rectB.right <= rectA.left ||
    rectB.top >= rectA.bottom ||
    rectB.bottom <= rectA.top
  );
